import axios from 'axios';

import ICvViewAnalytics from '../../../types/ICvViewAnalytics';
import { IJobCandidateInteraction } from '../../CandidateSearchService';

const url = 'wsreporting/api/';
const CsUrl = '/candidatesearch/api/candidate';

export const getTotalMappingsCount = (payload: IJobCandidateInteraction) =>
  axios.post(`${url}jobcrm-total-mappings-count`, payload);

export const getTotalApplicationsCount = (payload: IJobCandidateInteraction) =>
  axios.post(`${url}jobcrm-total-applications-count`, payload);

export const getSubmissionsCount = (payload: IJobCandidateInteraction) =>
  axios.post(`${url}jobcrm-total-submissions-count`, payload);

export const getMappingsBySourcePieChart = (payload: IJobCandidateInteraction) =>
  axios.post(`${url}jobcrm-get-mappings-by-source`, payload);

export const getSubmissionsBySourcePieChart = (payload: IJobCandidateInteraction) =>
  axios.post(`${url}jobcrm-get-submissions-by-source`, payload);

export const getMappingsByRecruiterJobsCRM = (payload: IJobCandidateInteraction) =>
  axios.post(`${url}jobcrm-get-mappings-by-recruiters`, payload);

export const getSubmissionsByRecruiterJobsCRM = (payload: IJobCandidateInteraction) =>
  axios.post(`${url}jobcrm-get-submissions-by-recruiters`, payload);

export const getJobsCrmSMSSent = (payload: IJobCandidateInteraction) =>
  axios.post(`${url}jobcrm-get-sms-sent`, payload);

export const getJobsCrmSMSSentBy = (payload: IJobCandidateInteraction) =>
  axios.post(`${url}jobcrm-get-sms-sentby`, payload);

export const getSpecificJobPipelineData = (payload: IJobCandidateInteraction) =>
  axios.post(`${url}jobcrm-get-specificJob-Pipeline`, payload);

export const getTimeToServiceJobStage = (payload: IJobCandidateInteraction) =>
  axios.post(`${url}jobcrm-get-timeToService-ApplicationStage`, payload);

export const getTimeToServiceAnalytics = (payload: IJobCandidateInteraction) =>
  axios.post(`${url}jobcrm-get-timeToService`, payload);

export const getSubmissionsTurnAroundTimeByStatus = (jobId: string) =>
  axios.post(`${CsUrl}/submissions-turn-around-time-by-stage/${jobId}`);

export const getSubmissionsTurnAroundTimeAndCandidateByStatus = (jobId: string) =>
  axios.post(`${CsUrl}/submissions-turn-around-time-and-candidate-by-stage/${jobId}`);

export const getTotalAISuggestionViewedCandidates = (payload: ICvViewAnalytics) =>
  axios.post(`${url}jobcrm-get-ai-suggestion-viewed-candidates`, payload);

export const getTotalAISuggestionMappedCandidates = (payload: IJobCandidateInteraction) =>
  axios.post(`${url}jobcrm-get-ai-suggestion-mapped-candidates`, payload);

export const getTotalAISuggestionSubmittedCandidates = (payload: IJobCandidateInteraction) =>
  axios.post(`${url}jobcrm-get-ai-suggestion-submitted-candidates`, payload);

export const getTotalAISuggestionViewedCandidatesByRecruiters = (payload: ICvViewAnalytics) =>
  axios.post(`${url}jobcrm-get-ai-suggestion-viewed-candidates-by-recruiters`, payload);

export const getTotalAISuggestionMappedCandidatesByRecruiters = (
  payload: IJobCandidateInteraction
) => axios.post(`${url}jobcrm-get-ai-suggestion-mapped-candidates-by-recruiters`, payload);
